import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogWidth, ThemePalette} from '@q9elements/ui-kit/common';
import {
  ConfirmModalDialogComponent,
  TwoFaRequiredDialogComponent
} from '@q9elements/ui-kit/components';

@Injectable({providedIn: 'root'})
export class SharedDialogService {
  constructor(private dialog: MatDialog) {}

  public showErrorDialog(message: string) {
    return this.dialog
      .open(ConfirmModalDialogComponent, {
        width: DialogWidth.SM,
        autoFocus: false,
        data: {
          modalTitle: 'GENERAL.ERROR',
          content: message,
          showCancelButton: false,
          confirmText: 'GENERAL.OK',
          color: ThemePalette.WARN
        }
      })
      .afterClosed();
  }

  public showTwoFactorDialog(gracePeriodExpired = false) {
    return this.dialog
      .open(TwoFaRequiredDialogComponent, {
        width: DialogWidth.SM,
        data: {gracePeriodExpired}
      })
      .afterClosed();
  }
}
